// extracted by mini-css-extract-plugin
export var image = "_io-1";
export var imageContainer = "_io-0";